import React from 'react';
import { useAuth } from '../context/AuthContext';

interface RequirePermissionProps {
    permission: string;
    children: React.ReactNode;
    fallback?: React.ReactNode;
}

/**
 * Envoltorio para renderizado condicional basado en permisos.
 * Si el usuario NO cuenta con el permiso otorgado, se renderiza el fallback (por defecto null).
 * Útil para ocultar botones (ej. "Crear Cliente") cuando un usuario solo tiene acceso "ver".
 */
export const RequirePermission: React.FC<RequirePermissionProps> = ({ 
    permission, 
    children, 
    fallback = null 
}) => {
    const { hasPermission } = useAuth();

    if (!hasPermission(permission)) {
        return <>{fallback}</>;
    }

    return <>{children}</>;
};

export default RequirePermission;
